import { Badge, Dropdown } from "react-bootstrap";
import { getJeepRallyMediaUrl } from "../../../../../../api/jeep-rally/api";
import { getCategoryTypeName } from "../../utils/category.utils";

const CategoryImage = ({ category }) => {
  const imageUrl = getJeepRallyMediaUrl(category?.image);

  if (!imageUrl) {
    return (
      <div
        className="d-flex align-items-center justify-content-center bg-light text-muted"
        style={{
          width: "56px",
          height: "40px",
          borderRadius: "6px",
          border: "1px solid #dee2e6",
          fontSize: "10px",
        }}
      >
        No image
      </div>
    );
  }

  return (
    <img
      src={imageUrl}
      alt={category?.title || "Category"}
      style={{
        width: "56px",
        height: "40px",
        objectFit: "cover",
        borderRadius: "6px",
        border: "1px solid #dee2e6",
      }}
    />
  );
};

const formatCcRange = (category) => {
  const min = category?.minCC;
  const max = category?.maxCC;
  if (min == null && max == null) return "-";
  if (max == null || max === "") return `${min ?? 0}+`;
  return `${min ?? 0}–${max}`;
};

const CategoriesTable = ({ categories, onView, onEdit, canManage }) => {
  return (
    <div className="table-responsive">
      <table className="table table-striped">
        <thead>
          <tr>
            <th>#</th>
            <th>Image</th>
            <th>Title</th>
            <th>Key</th>
            <th>Type</th>
            <th>CC</th>
            <th>Max Members</th>
            <th>Codriver</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {categories.map((category, index) => {
            const categoryId = category._id || category.id;
            const isActive = category.status !== "inactive";

            return (
              <tr key={categoryId || `${category.key}-${index}`}>
                <td>{index + 1}</td>
                <td>
                  <CategoryImage category={category} />
                </td>
                <td>{category.title || "-"}</td>
                <td>
                  <Badge bg="secondary">{category.key || "-"}</Badge>
                </td>
                <td>{getCategoryTypeName(category) || "-"}</td>
                <td>{formatCcRange(category)}</td>
                <td>{category.max_members ?? "-"}</td>
                <td>{category.navigator_allowed ? "Yes" : "No"}</td>
                <td>
                  <Badge bg={isActive ? "success" : "secondary"}>
                    {category.status || "-"}
                  </Badge>
                </td>
                <td className="text-center">
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="link"
                      className="p-0 text-decoration-none"
                    >
                      &#x2022;&#x2022;&#x2022;
                    </Dropdown.Toggle>
                    <Dropdown.Menu align="end">
                      <Dropdown.Item
                        onClick={() => onView(category)}
                        disabled={!categoryId}
                      >
                        View
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => onEdit(category)}
                        disabled={!categoryId || !canManage}
                      >
                        Edit
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default CategoriesTable;
